import React from "react";
import backgroundImage from "../assets/home/background.png";
import {TrendingUp, Users, Sparkles} from "lucide-react";
import {useAuth} from "../AuthContext";

const Home: React.FC = () => {
  const {isLoggedIn} = useAuth();

  return (
    <div className="home-page">
      <section className="hero hero-bg">
        <div className="hero-bg-image" aria-hidden="true">
          <img src={backgroundImage} alt="" />
        </div>
        <div className="hero-content">
          <h1 className="hero-title">The League of Fabled Pursuits</h1>
          <p className="hero-intro">
            A D&D league where players and DMs can dive into dynamic sessions on
            their own schedule, building an evolving adventure, whether a
            one-off dungeon crawl or a long-term saga.
          </p>
          <div className="hero-actions">
            <a href="/rules" className="btn btn-secondary">
              Learn the Rules
            </a>
            <a
              href={isLoggedIn ? "/env" : "/auth/register"}
              className="btn btn-secondary"
            >
              {isLoggedIn ? "Go to Dashboard" : "Join the Adventure"}
            </a>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon">
                <TrendingUp size={48} />
              </div>
              <h3>Living Adventure</h3>
              <h4>Seamless Character Progression</h4>
              <p>
                Characters and choices carry across sessions and tables,
                building a legacy that grows over time—for players and DMs
                alike.
              </p>
            </div>
            <div className="feature">
              <div className="feature-icon">
                <Sparkles size={48} />
              </div>
              <h3>Flexible Campaigns</h3>
              <h4>Play your way, DM your way</h4>
              <p>
                Hop between themes, tables, and DM styles. Whether you’re
                chasing chaos or deep lore, there’s always a new thread to pull.
              </p>
            </div>
            <div className="feature">
              <div className="feature-icon">
                <Users size={48} />
              </div>
              <h3>Community & Creativity</h3>
              <h4>Forge stories together</h4>
              <p>
                The League is a vibrant community, started in Amsterdam, that
                supports players and DMs in a shared world of their own
                creation.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
